import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-requisition-status-radio-buttons',
  templateUrl: './requisition-status-radio-buttons.component.html',
  styleUrls: ['./requisition-status-radio-buttons.component.scss']
})
export class RequisitionStatusRadioButtonsComponent implements OnInit, OnDestroy {
  public status: string[];
  public selected: string = '';
  @Input() public control: UntypedFormControl = new UntypedFormControl();
    private onDestroy$: Subject<void> = new Subject<void>();

  constructor() {
    this.status = [
      'Pending',
      'Done',
      'All'
    ];
  }

  public valueChanged() {
    this.control.setValue(this.selected);
  }

  public ngOnInit() {
    this.selected = this.status[0];
    this.valueChanged();

    this.control.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((values) => {
      if (values === undefined || values === null) {
        this.selected = this.status[2];
      }
    });
  }

    public ngOnDestroy(): void {
      this.onDestroy$.next();
      this.onDestroy$.complete();
    }

}
